import { instance } from '../api/api';

export interface IEdsKeyUpload {
  key: File;
  profileID: string;
}

export const EdsService = {
  async uploadEdsKey(keyFile: File, profileID: string): Promise<any> {
    try {
      const formData = new FormData();
      formData.append('key', keyFile);
      formData.append('profileID', profileID);

      const { data } = await instance.put('/sign/key', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Не удалось загрузить EDS ключи');
    }
  },
};
